import _ from 'lodash'
import jose from 'node-jose'

const keyVerification = {
  /**
   * verify src-payload -verification key
   * @param checkoutResponse
   * @returns {Promise<*>}
   */
  async verifyKey (checkoutResponse, srcKeys) {
    let checkoutResponseSignature = checkoutResponse.checkoutResponseSignature || ''
    let checkoutSignature = checkoutResponseSignature.includes('.') ? (checkoutResponse.checkoutResponseSignature).split('.')[0] : checkoutResponseSignature
    let headerData = JSON.parse(atob(checkoutSignature))

    let webKey = ''
    _.forEach(srcKeys, srcKey => {
      if (srcKey.kid.includes(headerData.kid)) {
        webKey = srcKey
      }
    })
    var identityVerificationkey = [{
      'kty': webKey.kty,
      'e': webKey.e,
      'use': webKey.use,
      'kid': webKey.kid,
      'key_ops': [
        webKey.key_ops
      ],
      'alg': webKey.alg,
      'n': webKey.n
    }]

    let keystore
    let data
    jose.JWK.asKeyStore(identityVerificationkey)
      .then(function (result) {
        keystore = result

        jose.JWS.createVerify(keystore).verify(checkoutResponse.checkoutResponseSignature).then(function (result1) {
          if (result1) {
            data = result1
          }
        })
      })
    return data
  }
}

export default keyVerification
